import Proptypes from "prop-types";
import Modal from "@shared/v2/Modal";
import PersonInteractionEmailForm from "../../PersonDetail/components/PersonInteractionEmailForm";

const EmailModal = ({
  gmailUnsynced,
  sendEmailError,
  sendEmailUrl,
  isEmailSent,
  person,
  currentUserId,
  emailTemplates,
  modalOpen,
  closeModal,
  submitEmail,
  handleSubmitEmailError,
  defaultHomeAppTabContent,
}) => (
  <Modal
    id="email-interaction-modal"
    show={modalOpen}
    onHide={closeModal}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[600px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Interaction: Email" closeButton />

    <Modal.Body>
      <PersonInteractionEmailForm
        defaultHomeAppTabContent={defaultHomeAppTabContent}
        gmailUnsynced={gmailUnsynced}
        sendEmailError={sendEmailError}
        send_email_url={sendEmailUrl}
        isEmailSent={isEmailSent}
        submitEmail={submitEmail}
        handleSubmitEmailError={handleSubmitEmailError}
        person={person}
        emailTemplates={emailTemplates}
        current_user_id={currentUserId}
        closeModal={closeModal}
      />
    </Modal.Body>
  </Modal>
);

EmailModal.propTypes = {
  gmailUnsynced: Proptypes.bool.isRequired,
  person: Proptypes.shape({ full_name: Proptypes.string }),
  currentUserId: Proptypes.number,
  emailTemplates: Proptypes.arrayOf(
    Proptypes.shape({
      name: Proptypes.string,
    }),
  ),
  modalOpen: Proptypes.bool,
  closeModal: Proptypes.func,
  isEmailSent: Proptypes.bool,
  sendEmailError: Proptypes.shape({ content: Proptypes.string, type: Proptypes.string }),
  submitEmail: Proptypes.func,
  handleSubmitEmailError: Proptypes.func,
  sendEmailUrl: Proptypes.string,
  defaultHomeAppTabContent: Proptypes.string,
};
EmailModal.defaultProps = {
  person: null,
  currentUserId: null,
  emailTemplates: [],
  modalOpen: false,
  closeModal: null,
  isEmailSent: false,
  sendEmailError: null,
  submitEmail: null,
  handleSubmitEmailError: null,
  sendEmailUrl: null,
  defaultHomeAppTabContent: null,
};

export default EmailModal;
